module.exports = __webpack_public_path__ + "img/streaming_poster.e5c8a934.jpg";